Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yTickStyles = exports.xTickStyles = exports.yAxisStyles = exports.xAxisStyles = exports.gridStyles = exports.labelStyles = exports.colors = undefined;

var _color = require('./color');

var _color2 = _interopRequireDefault(_color);

var _font = require('./font');

var _font2 = _interopRequireDefault(_font);

var _svgLabel = require('./svgLabel');

var _size = require('./size');

var _size2 = _interopRequireDefault(_size);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var colors = exports.colors = _color2['default'];

var labelStyles = exports.labelStyles = Object.assign({}, _svgLabel.baseLabel, _font2['default'].light);

var gridStyles = exports.gridStyles = {
  stroke: colors.grid,
  strokeWidth: 1
};

var xAxisStyles = exports.xAxisStyles = {
  stroke: colors.gridDark,
  strokeWidth: 2,
  label: {
    bottom: Object.assign({}, _svgLabel.baseLabel),
    top: Object.assign({}, _svgLabel.baseLabel)
  }
};

var yAxisStyles = exports.yAxisStyles = {
  stroke: colors.grid,
  strokeWidth: 1,
  label: {
    left: Object.assign({}, _svgLabel.baseLabel),
    right: Object.assign({}, _svgLabel.baseLabel)
  }
};

var xTickStyles = exports.xTickStyles = {
  stroke: colors.grid,
  length: 1 * _size2['default'],
  label: {
    bottom: Object.assign({}, _svgLabel.tickLabels.bottom),
    top: Object.assign({}, _svgLabel.tickLabels.top)
  }
};

var yTickStyles = exports.yTickStyles = {
  stroke: colors.grid,
  length: 1 * _size2['default'],
  label: {
    left: Object.assign({}, _svgLabel.tickLabels.left),
    right: Object.assign({}, _svgLabel.tickLabels.right)
  }
};

exports['default'] = {
  colors: colors,
  labelStyles: labelStyles,
  gridStyles: gridStyles,
  xAxisStyles: xAxisStyles,
  xTickStyles: xTickStyles,
  yAxisStyles: yAxisStyles,
  yTickStyles: yTickStyles
};